import { Layout, Spacer } from '@ui-kit'

import { UnavailablePlansAlert } from './components/Alerts'
import { PromotionForFreePlan } from './components/Banners/PromotionForFreePlan'
import { Header } from './components/Header'
import { PlanPanels } from './components/PlanPanels'

export const Plans = () => (
  <Layout width={1200}>
    <Header />

    <Spacer space={40} />

    {/* TODO: Black Friday banner */}
    {/* <BlackFridayPromotion /> */}

    <PromotionForFreePlan />

    <UnavailablePlansAlert />

    <PlanPanels />

    <Spacer space={40} />
  </Layout>
)

Plans.displayName = 'CheckoutPlans'
